import { JobDocumentList } from './../model/jobDocument';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { GetModeFinancement } from '../store/actions/chart.actions';
import { BusinessDocumentList } from '../model/businessDocument.model';

@Injectable({
    providedIn: 'root'
})
export class ElasticSearchService {
    apiUrl = environment.server;

    constructor(private _httpClient: HttpClient) { }

    getJobDocument(parameters: HttpParams): Observable<JobDocumentList> {
        return this._httpClient.get<JobDocumentList>(this.apiUrl + 'elastic_search/jobs/', {
            params: parameters
        });
    }

    getBusinessDocument(parameters: HttpParams): Observable<BusinessDocumentList> {
        return this._httpClient.get<BusinessDocumentList>(this.apiUrl + 'elastic_search/business/', {
            params: parameters
        });
    }

    getGraphCountDoneLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/count_done_lilates/', {
            params: params
        });
    }

    getGraphCreatedLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/count_created_lilates/', {
            params: params
        });
    }

    getGraphMonthlyCreatedLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/monthly_created_lilates/', {
            params: params
        });
    }

    getGraphLilateCheckDataByYear(): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/check_data_by_year_lilates/');
    }

    getGraphLilateLanguages(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/languages_lilates/', {
            params: params
        });
    }

    getGraphLilateTauxPassage(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/taux_passage_lilates/', {
            params: params
        });
    }

    getGraphLilateSuccess(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/success_status_lilates/', {
            params: params
        });
    }

    getGraphLilateTauxPassagePerLangues(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/taux_passage_per_languages_lilates/', {
            params: params
        });
    }

    getGraphLilateSuccessPerLangues(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/success_status_per_languages_lilates/', {
            params: params
        });
    }

    getGraphLilateStatus(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/status_lilates/', {
            params: params
        });
    }

    getGraphLilateLevel(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/level_lilates/', {
            params: params
        });
    }

    getGraphLilateLevelPerLanguages(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/level_per_languages_lilates/', {
            params: params
        });
    }

    getGraphLilateNps(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/nps_lilates/', {
            params: params
        });
    }

    getGraphLilateCsat(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/csat_lilates/', {
            params: params
        });
    }

    getGraphCarbon(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/sum_bilan_carbone_lilates/', {
            params: params
        });
    }

    GetModeFinancement(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/mode_financement_lilates/', {
            params: params
        });
    }

    getGraphGenderLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/gender_lilates/', { params });
    }

    getGraphJobSituationLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/job_situation_lilates/', { params });
    }

    getGraphJobLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/job_lilates/', { params });
    }

    getGraphBusinessLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/business_lilates/', { params });
    }

    getGraphInTrainingLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/in_training_lilates/', { params });
    }

    getGraphIdentityIssueCountLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/identity_issue_count_lilates/', { params });
    }

    getGraphPhotoStatusRefusedCountLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/photo_status_refused_count_lilates/', { params });
    }

    getGraphUniqueCompaniesCountLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/unique_companies_count_lilates/', { params });
    }

    getGraphAverageAgeLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/average_age_lilates/', { params });
    }

    getGraphAgeRangeCountLilates(params: HttpParams): Observable<any> {
        return this._httpClient.get<any>(this.apiUrl + 'elastic_search/graphs/age_range_count_lilates/', { params });
    }
}
